export enum ActionTypes {
  FETCH_USER_STATUS = "FETCH_USER_STATUS",
  USER_LOGIN = "USER_LOGIN",
  USER_LOGOUT = "USER_LOGOUT",
  USER_REQUEST_PASSWORD_RESET = "USER_REQUEST_PASSWORD_RESET",
  USER_ONETIME_LOGIN = "USER_ONETIME_LOGIN",
  USER_VALIDATE_SIGNUP = "USER_VALIDATE_SIGNUP",
  USER_REGISTER = "USER_REGISTER"
}
